import colors from '#core/design-system/colors.json'
import type { CMSConfig } from '#types/config/components/cms'

export default {
  defaultLinksHoverColor: colors.grey['20']
} satisfies CMSConfig['richText']
